import { Theme } from "@material-ui/core";

export const quotationFormStyles = ({ palette, spacing }: Theme) => {
    return {

        formTitle: {
            marginBottom: spacing.unit * 4
        },

        /* */

        squareBox: {
            border: `3px solid ${palette.primary.main}`,
            padding: spacing.unit * 2,
        },

        squareBoxLine: {
            marginTop: spacing.unit,
            background: palette.primary.main,
            height: "3px"
        },

        box: {
            padding: spacing.unit * 2
        },

        /* */

        guarantyBox: {
            padding: `${spacing.unit * 2}px !important`,
            border: `1px solid ${palette.primary.main}`
        },

        guarantyBoxOptional: {
            padding: `${spacing.unit * 2}px !important`,
            background: `${palette.primary.light}`,
            borderRight: `1px dashed ${palette.primary.main}`,
            "&:last-child": {
                borderRight: 0
            }
        },

        guarantyBoxBackground: {
            padding: `${spacing.unit * 2}px !important`,
            background: `${palette.primary.light}`
        },

        guarantyBoxCheckbox: {
            minHeight: "60px"
        },

        guarantyBoxInput: {
            marginTop: spacing.unit * 4
        },    

        guarantyBoxResult: {
            paddingTop: spacing.unit * 2,
            minHeight: "20px"
        },

        guarantyBoxTotal: {
            width: `100%`,
            background: `${palette.primary.main}`,
            padding: spacing.unit * 3,
            marginTop: "2px"
        },

        /* */

        cotisationsBox: {
            border: `1px solid ${palette.primary.main}`,
            padding: spacing.unit * 2
        },

        cotisationsBoxTitle: {
            marginTop: spacing.unit * 2,
            marginBottom: spacing.unit
        },

        cotisationsBoxItem: {
            marginTop: spacing.unit,
            marginBottom: spacing.unit,
            padding: spacing.unit
        },

        cotisationsBoxSubItem: {
            marginTop: spacing.unit,
            marginBottom: spacing.unit,
            marginLeft: spacing.unit,
            padding: spacing.unit
        },
        
        cotisationsBoxInfo: {
            marginTop: spacing.unit,
            fontStyle: "italic"
        },

        cotisationsBoxResume: {
            background: `${palette.primary.main}`,
            padding: spacing.unit * 3            
        },

        cotisationsBoxResumeItem: {
            color: "white"
        },

        /* */
        
        annuityImmediateItem: {
            paddingTop: spacing.unit * 3
        },

        beneficiaryBox: {
            padding: spacing.unit * 2,
            marginRight: spacing.unit,
            marginBottom: spacing.unit * 2,
            marginTop: spacing.unit * 2,
            "&:first-child": {
                marginTop: 0
            }
        }
    };
};


// WEBPACK FOOTER //
// ./src/components/QuotationForm/QuotationForm.styles.ts